export default __webpack_public_path__ + "static/media/filterChipsActiveIcon.3ed74d7a.svg";